// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Hgh7","select":"styles_select__1anag"};